export * from './mvk.component';

